import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import AppLink, { pushAppRoute } from '../../links/AppLink';
import { Icon } from 'edcom-ui';
import styles from './GuidedLessonAction.module.less';

const GuidedLessonAction = ({ href }) => {
  if (!href) return null;

  const router = useRouter();
  const guidedLessonLink = `/guided-lesson/${href}/`;

  return (
    <div className={styles.wrapper}>
      <div className={styles.action}>
        <Icon
          name="guided-lessons"
          className={styles.icon}
          onClick={() => pushAppRoute(router, guidedLessonLink)}
        />
        <AppLink href={guidedLessonLink} className={styles.link}>
          See in a Guided Lesson
        </AppLink>
      </div>
    </div>
  );
};

GuidedLessonAction.propTypes = {
  href: PropTypes.string,
};

export default GuidedLessonAction;
